/**
 * Heat Loss Calculator: Utils
 * ===
 * Utility methods for the Heat Loss Calculator
 * 
 *
 * Copyright (c) August 2024 · Art & Soul Communications Ltd.
 * https://artandsoul.co.uk
 *
 */

'use strict';

export var HLC_Utils = {
    
    wattsToBtus: function(watts) {
        return Math.round(watts * 3.41442594972);
    }
    
};
